import { Box, MultiSelectField, NumberField } from '@medely/ui-kit';
import { Market } from '@mp/hooks';
import React, { useEffect } from 'react';
import { useWatch } from '@medely/ui-kit/react-hook-form';

type MarketsFormFieldsProps = {
  initialZipCode?: string | null;
  markets: Market[];
  onZipCodeChange: (value: string) => void;
};

export const MarketsFormFields = ({
  initialZipCode,
  markets,
  onZipCodeChange,
}: MarketsFormFieldsProps) => {
  const raw = useWatch({ name: 'zipCode' });
  const digits = String(raw ?? '').replace(/\D/g, '');
  const normalized = digits.padStart(5, '0').slice(0, 5);

  useEffect(() => {
    if (digits.length === 5) {
      onZipCodeChange(normalized);
    }
  }, [digits, normalized, onZipCodeChange]);

  const isMarketZipCodePresent = (
    market: Pick<Market, 'market_locations'>,
  ): boolean | undefined => {
    return market.market_locations
      ?.flat()
      ?.map((ml) => ml.zip_code)
      ?.includes(initialZipCode || '');
  };

  const marketOptions = markets.map((market) => ({
    value: market.id as number,
    label: market.display_name as string,
    disabled: isMarketZipCodePresent(market),
  }));

  return (
    <>
      <Box testId="markets-zip">
        <NumberField name="zipCode" label="Zip code" testId="markets-zip" maxDigits={5} />
      </Box>
      <Box pt={2}>
        <MultiSelectField
          options={marketOptions}
          name="market_ids"
          variant="list"
          label=""
          testId="markets-market-box"
        />
      </Box>
    </>
  );
};
